import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=fb3a2138&scoped=true&"
import script from "./Text.vue?vue&type=script&lang=ts&"
export * from "./Text.vue?vue&type=script&lang=ts&"
import style0 from "./Text.vue?vue&type=style&index=0&id=fb3a2138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3a2138",
  null
  
)

export default component.exports